import React from "react";
import axios from "axios";
import lodash from "lodash";
import { inject, observer } from "mobx-react";

import Loading from "../general/Loading";
import Header from "./Header";
import ListMessages from "./ListMessages";

@inject("messagingStorage")
@observer
class Messaging extends React.Component {
  state = {
    templates: [],
    currentUserIsAdmin: window.Application.currentUser.admin
  };

  componentWillMount() {
    axios.get("/message_templates").then(({ data }) => {
      this.setState({ templates: data });
    });
  }

  render() {
    const { messagingStorage, noRecordsMessage } = this.props;
    const searchWords = messagingStorage.search.split(" ");

    return (
      <div>
        <Header
          currentUserIsAdmin={this.state.currentUserIsAdmin}
          templates={this.state.templates}
          search={messagingStorage.search}
          onChangeSearch={this.handlerChangeSearch}
          onAdded={this.handlerAddedNewTemplate}
          onDelete={this.handlerDeleteTemplate}
          onUpdated={this.onUpdated}
        />
        <br />

        {messagingStorage.messages.length === 0 && !messagingStorage.loading ? (
          <p className="grey-text center-text">{noRecordsMessage}</p>
        ) : (
          <div>
            <ListMessages
              searchString={messagingStorage.search}
              data={messagingStorage.messages}
              destroyMessage={messagingStorage.destroyMessage}
              currentUserIsAdmin={this.state.currentUserIsAdmin}
            />

            {messagingStorage.loading || messagingStorage.stop ? null : (
              <div className="center-text">
                <a
                  href="javascript:void(0);"
                  className="btn btn-text-grey"
                  onClick={messagingStorage.loadMessages}
                >
                  LOAD MORE
                </a>
              </div>
            )}
          </div>
        )}

        <Loading loading={messagingStorage.loading} />
      </div>
    );
  }

  handlerChangeSearch = e => {
    const { messagingStorage } = this.props;
    messagingStorage.updateSearch(e.target.value);
  };

  handlerAddedNewTemplate = dataNewTemplate => {
    const tmp = this.state.templates;
    tmp.push(dataNewTemplate);

    this.setState({ templates: tmp });
  };

  handlerDeleteTemplate = e => {
    if (!confirm("Are you sure you want to delete this template?")) {
      return;
    }

    const id = parseInt(e.target.getAttribute("data-id"));
    const templates = this.state.templates;
    const idx = lodash.findIndex(templates, { id: id });
    templates.splice(idx, 1);
    this.setState({ templates });

    axios.delete(`/message_templates/${id}`);
  };

  handlerDeleteMessage = e => {
    if (!confirm("Are you sure you want to delete this message?")) {
      return;
    }

    const id = parseInt(e.target.getAttribute("data-id"));
    const templates = this.state.templates;
    const idx = lodash.findIndex(templates, { id: id });
    templates.splice(idx, 1);
    this.setState({ templates });

    axios.delete(`/message_templates/${id}`);
  };

  onUpdated = newDataTemplate => {
    const templates = this.state.templates;
    const idx = lodash.findIndex(templates, { id: newDataTemplate.id });
    templates[idx] = newDataTemplate;

    this.setState({ templates });
  };
}

export default Messaging;
